'use strict';

angular.module('adminDefaultEntitlementControllers')

.controller('ViewSupervisorDetailsController', ['$scope', '$state', '$stateParams', 'adminDefaultEntitlementService', 'impactedEmployees', function ($scope, $state, $stateParams, adminDefaultEntitlementService, impactedEmployees) {
    $scope.infos.displaySearch = false;

    $scope.systemId = $stateParams.systemId;
    $scope.systemRoleId = $stateParams.systemRoleId;
    $scope.supervisorId = $stateParams.supervisorId;
    $scope.impactedEmployees = impactedEmployees;

    $scope.removeDefaultEntitlement = function () {
        adminDefaultEntitlementService.removeDefaultEntitlement($scope.systemRoleId, $scope.supervisorId)
            .then(function () {
                $state.go('adminDefaultEntitlement.bySystemRole.viewExistingRights', {
                    systemId: $scope.systemId,
                    systemRoleId: $scope.systemRoleId
                }, {
                    reload: true
                });
            });
    }
}]);
